import { Avatar } from '@lmc/ui-kit'
import InfoIcons from 'screens/Rostering/RotaBuilder/common/components/InfoIcons'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'
import { theme } from '@lmc/ui-kit'

type TeamMemberInfoProps = {
  user: any
}

const TeamMemberInfo = ({ user }: TeamMemberInfoProps) => {
  const { t } = useTranslation()

  const assignedHours =
    user && user.assignedMinutes
      ? Math.round((user.assignedMinutes / 60) * 2) / 2
      : 0

  const contractedHours = user?.workProfile?.contractedHoursPerWeek ?? user?.contractedHoursPerWeek
  const hoursText = contractedHours != null
    ? `${assignedHours}h/${contractedHours}h`
    : `${assignedHours}h/${t('NOT_ADDED')}`

  return (
    <SectionWrapper>
      <Row>
        <Info>
          <Avatar url={user.picture as unknown as string} size={18} />
          <PrimaryText level={1.5} weight="medium">
            {`${user.name.first} ${user.name.last}`}
          </PrimaryText>
        </Info>
      </Row>
      <Info>
        <PrimaryText level={2} weight="medium">
          {hoursText}
        </PrimaryText>
        {user.workProfile?.canDoOvertime && (
          <>
            <Text level={2}>·</Text>
            <Tooltip
              placement="bottom"
              color={theme.color.neutral.color3}
              title={
                <ContentContainer>
                  <Text>{t('WILLING_TO_WORK_OVERTIME')}</Text>
                </ContentContainer>
              }
            >
              <Text level={2}>OT</Text>
            </Tooltip>
          </>
        )}
      </Info>
      <Row>
        <SecondaryText level={2} weight="medium">
          {t(user.role)}
        </SecondaryText>
        <InfoIcons
          email={user.email}
          phone={user.phoneNumber}
          notes={user.workProfile?.rotaPreferenceNotes}
        />
      </Row>
    </SectionWrapper>
  )
}

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 168px;
`
const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`
const Info = styled(Row)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  justify-content: start;
`
const PrimaryText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color3};
`

const SecondaryText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 8px;
  color: ${(props) => props.theme.color.neutral.color11};
`

export default TeamMemberInfo
